<template>
<div class="form-body">
  <div v-show="loading != 0" class="row">
    <div class="col-sm-12">
      <h2>{{ trans('form.please_wait') }}...</h2>
      <ring-loader></ring-loader>
    </div>
  </div>
  <div v-show="loading == 0">
    <div class="row">
      <div class="col-sm-12">
          <singleselect
                  :checked="companyClient.client ? companyClient.client.id : null"
                  name="client"
                  label="email"
                  :title="trans('company_client.entity.client.email')"
                  :allow-empty="false"
                  :errors="form.options.errors"
                  :options="clients"
                  @search="findClients"
                  @dispatch="clientSelected"
          >
          </singleselect>
      </div>
      <div class="col-sm-12">
          <checkbox
                  v-model="companyClient.isActive"
                  name="active"
                  :checked="companyClient.isActive"
                  :label="trans('company_client.entity.active')"
          >
          </checkbox>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import toastr from '../toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import debounce from 'lodash.debounce'

export default {
  components: {
    Checkbox,
    RingLoader,
    Singleselect
  },
  props: {
    companyId: {
      type: [String, Number],
      default: null,
    },
    save: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      loading: 0,
      clients: [],
      companyClient: {
        company: {},
        client: null,
        isActive: true
      },
      form: {
        options: {
          errors: {}
        }
      }
    }
  },
  watch: {
    'save': function (val) {
      if (val) {
        this.saveCompanyClient()
      }
    }
  },
  methods: {
    trans (name) {
      return Translator.trans(name)
    },
    clientSelected(client) {
      this.companyClient.client = client.id
    },
    saveCompanyClient () {
      this.loading ++
      const url = Routing.generate('api_post_company_client')
      this.companyClient.company = this.companyId
      Vue.http.post(url, {
        'data': this.companyClient
      }).then(() => {
        this.form.options.errors = {}
        toastr.success(Translator.trans('form.updated'))
        this.loading --
        this.$emit('company-client-saved')
      }, response => {
        this.handleAjaxError(response, this.form.options)
        this.loading --
        this.$emit('company-client-save-failed')
      })
    },
    findClients(email) {
      if (email.length) {
        this.search(email)
      }
    },
    search: debounce(function(email) {
      const url = Routing.generate('api_get_clients_email', { email })
      Vue.http.get(url).then(response => {
        this.clients = response.data
      }, response => {
        this.handleAjaxError(response)
      })
    }, 500),
  },
}
</script>
